import PageLayout from "@/react/features/styled/PageLayout";
import { CustomerCard } from "@/react/features/customer";
import styled from "styled-components";
import FullWidthDiv from "@/react/features/styled/FullWidthDiv";
import { useLocation, useNavigate } from "react-router-dom";
import { TrunkGatewaysList } from "../components/TrunkGatewaysList";
import { useAvailableLicenseForTrunks } from "../useAvailableLicenseForTrunks";
import { StyledButton, StyledPlusIcon } from "../styled";

const TrunksContainer = styled.div`
  display: block;
`;

const HeaderContainer = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  width: 100%;
  max-width: 1000px;
`;

const TrunkGatewaysPage = () => {
  const { licenseExists } = useAvailableLicenseForTrunks();
  const navigate = useNavigate();
  const location = useLocation();

  const handleCreate = () => {
    navigate(`${location.pathname}/create`);
  };

  return (
    <PageLayout>
      <CustomerCard />
      <FullWidthDiv>
        <TrunksContainer>
          <HeaderContainer>
            <h4>Trunk Gateways</h4>
            <StyledButton
              isDisabled={!licenseExists}
              variant={"text"}
              onClick={handleCreate}
            >
              <StyledPlusIcon /> Create Gateway
            </StyledButton>
          </HeaderContainer>
          <TrunkGatewaysList />
        </TrunksContainer>
      </FullWidthDiv>
    </PageLayout>
  );
};

export default TrunkGatewaysPage;
